import { Grid } from '@mui/material';
import {
  ProtesisTramitesIniciadoAutorizado,
  ProtesisTramitesPorDelegacion,
  ProtesisTramitesProvider,
} from '../components';

export const ProtesisMain = () => {
  return (
    <Grid container spacing={2}>
      <Grid item container spacing={2} xs={12} md={6}>
        <ProtesisTramitesProvider>
          <ProtesisTramitesIniciadoAutorizado />
        </ProtesisTramitesProvider>
      </Grid>

      <Grid item container spacing={2} xs={12} md={6}>
        <ProtesisTramitesPorDelegacion />
      </Grid>
    </Grid>
  );
};
